import { render, staticRenderFns } from "./GroupUsersDialog.vue?vue&type=template&id=9355a240"
import script from "./GroupUsersDialog.vue?vue&type=script&lang=js"
export * from "./GroupUsersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports